"use client";

import React from "react";
import { useCardGridItemContext } from "./CardGridItemContext";
import { CardPrimaryPrice } from "modules/cards/components/CardPrimaryPrice";

export function CardGridItemQuantityPrice() {
  const { item } = useCardGridItemContext();

  return (
    <div className="flex items-center gap-1 text-sm">
      <span>{item.quantity}x</span>
      {item.price && (
        <CardPrimaryPrice card={item} className="font-medium" />
      )}
    </div>
  );
}
